import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { API_SERVER, API_SERVER_VERSION } from '../../app.constants';
import { User } from '../user/user.model';
import { deserialize } from 'json-typescript-mapper';

@Injectable()
export class AccountService  {
    constructor(private http: Http) { }

    get(): Observable<any> {
      return this.http.get(API_SERVER + 'api/' + API_SERVER_VERSION + '/account').map(function(res: Response) {
        const body = res.json();
        return deserialize<User>(User, body);
      });
    }

    save(account: any): Observable<Response> {
        return this.http.post(API_SERVER + 'api/' + API_SERVER_VERSION + '/account', account);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/account.service.ts